
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8.25v-5.5A2.749 2.749 0 012.75 0h5.5A2.749 2.749 0 0111 2.75v5.5A2.752 2.752 0 018.25 11h-5.5A2.749 2.749 0 010 8.25z","fill":"#FF2D55"}}),_c('path',{attrs:{"d":"M2.121 1.212L1.008 2.325 8.8 10.118l1.113-1.113-7.792-7.793z","fill":"#00011F"}}),_c('path',{attrs:{"d":"M8.8 1.012L1.008 8.804l1.113 1.113 7.792-7.792L8.8 1.012z","fill":"#00011F"}})])
          )
        }
      }
    